export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\"><path d=\"M5.5 13.026v-1.5h13v1.5h-13Z\"/></svg>\n"